import { render } from "./EditOlt.vue?vue&type=template&id=3252ad9d&scoped=true"
import script from "./EditOlt.vue?vue&type=script&lang=js"
export * from "./EditOlt.vue?vue&type=script&lang=js"

import "./EditOlt.vue?vue&type=style&index=0&id=3252ad9d&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3252ad9d"]])

export default __exports__